module.exports = __webpack_public_path__ + "static/media/H_detectDataImage.a2f23584.png";